import { createAction } from "@reduxjs/toolkit";

export const actions = {
    SESSION_LOGIN: 'SESSION_LOGIN',
    SESSION_LOGOUT: 'SESSION_LOGOUT',
};

export const sessionLogin = createAction<string>(
    actions.SESSION_LOGIN,
);